import { getSubgroupsFromDayDate } from 'shared/lib';

export const formatDayDate = (dayDate: string | undefined) => {
  if (dayDate) {
    const dayDateArr = getSubgroupsFromDayDate(dayDate);
    if (dayDateArr.length) {
      return (
        <>
          <span>{dayDateArr[0].join(' ')}</span>
          <br />/<br />
          <span>{dayDateArr[1].join(' ')}</span>
        </>
      );
    }
  }
  return dayDate;
};
